module.exports = __webpack_public_path__ + "static/img/profileMenuArrowDown.66559f5.svg";